import { TableCell, TableHead, TableRow } from '@material-ui/core';
import React from 'react';
import { useTableStyles } from './Subledger.styled';
import { useAccountProvider } from '../../core/accountContext';

const PostJETableHeader = () => {
  const tableClasses = useTableStyles();
  const { account } = useAccountProvider();

  return (
    <TableHead>
      <TableRow
        hover={false}
      >
        <TableCell className={tableClasses.assetCell}>
          JE LINE
        </TableCell>
        <TableCell className={tableClasses.assetCell}>
          PREPAID ID
        </TableCell>
        <TableCell className={tableClasses.descriptionCell}>
          Description
        </TableCell>
        <TableCell className={tableClasses.customerCell}>
          Vendor
        </TableCell>
        <TableCell className={tableClasses.expenseAccountCell}>
          Expense Account
        </TableCell>
        {
          (account?.classTrackingPerTxnLine || account?.classTrackingPerTxn) && (
            <TableCell className={tableClasses.classesCell}>
              Class
            </TableCell>
          )
        }
        <TableCell className={tableClasses.prepaidAssetAmount}>
          DR
        </TableCell>
        <TableCell className={tableClasses.prepaidAssetAmount}>
          CR
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default React.memo(PostJETableHeader);
